import React from 'react';
import { motion } from 'framer-motion';
const steps = [{
  icon: '🛒',
  number: '01',
  title: 'CHOOSE',
  description: 'Choose the concept, skill, project or classroom need you want to work on.'
}, {
  icon: '📥',
  number: '02',
  title: 'OPEN',
  description: 'Open the corresponding volume, activity, visual reference or teaching tool.'
}, {
  icon: '🎓',
  number: '03',
  title: 'TEACH',
  description: 'Print it, project it or use it alongside the way you already teach.'
}];
export function HowItWorks() {
  return <section className="w-full bg-navy px-5 py-10 sm:py-16" data-id="element-117" data-mp="qi1qxnealw8j">
      <div className="mx-auto max-w-5xl" data-id="element-118" data-mp="cs80j0n533wp">
        <div className="mx-auto max-w-2xl text-center" data-id="element-119" data-mp="cr6n4pini5bt">
          <h2 className="font-display text-2xl font-bold leading-tight text-white sm:text-4xl" data-id="element-120" data-mp="gtbibsoqza0k">
            Choose. Open. Teach.
          </h2>
          <p className="mt-3 text-sm text-white/70 sm:text-base" data-id="element-121" data-mp="14hkyof36z5kb">
            Three simple steps between knowing what your students need and having a classroom-ready
            resource in front of you.
          </p>
        </div>
        <div className="mt-7 flex flex-col gap-5 sm:mt-10 md:flex-row md:gap-6" data-id="element-122" data-mp="2rjbi96e20onz">
          {steps.map((step, index) => <React.Fragment key={step.number} data-id="element-123" data-mp="31bhamh87x83p" data-mpi={index}>
              <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            amount: 0.3
          }} transition={{
            duration: 0.3,
            delay: index * 0.06,
            ease: [0.23, 1, 0.32, 1]
          }} className="flex flex-1 flex-col items-center text-center" data-id="element-124" data-mp="31c96zu9n39v1">
                <span className="flex h-16 w-16 items-center justify-center rounded-full border border-gold/50 bg-navy-mid text-3xl" data-id="element-125" data-mp="3k9k3j73vzp6s">
                  {step.icon}
                </span>
                <span className="mt-4 font-display text-2xl font-bold text-gold" data-id="element-126" data-mp="1pwua0qhfkhzx">{step.number}</span>
                <h3 className="mt-2 text-lg font-bold text-white" data-id="element-127" data-mp="1kyseh62tiq7k">{step.title}</h3>
                <p className="mt-3 max-w-xs text-sm leading-relaxed text-white/70" data-id="element-128" data-mp="3l0iimbddnusu">
                  {step.description}
                </p>
              </motion.div>
              {index < steps.length - 1 && <div className="mx-auto h-5 w-px bg-gold/35 md:hidden" aria-hidden="true" data-id="element-129" data-mp="3tz3xnwjn4rov" />}
            </React.Fragment>)}
        </div>
        <div className="mx-auto mt-8 max-w-2xl text-center sm:mt-12" data-id="element-130" data-mp="2v5jmrz8wrhg">
          <p className="text-lg font-bold text-gold" data-id="element-131" data-mp="7rvun0w70ww0">You Keep Your Teaching Freedom.</p>
          <p className="mt-3 text-sm leading-relaxed text-white/70 sm:text-base" data-id="element-132" data-mp="cr8j1q2pqc0p">
            THE COMPLETE ART YEAR™ doesn&apos;t replace your teaching style. It gives you a strong,
            organized starting point so you don&apos;t have to build every resource yourself.
          </p>
        </div>
      </div>
    </section>;
}